import { h, render } from 'preact';
import clsx from 'clsx';
import BeveledIcon from './BeveledIcon';

export const Button = ({
  disabled,
  type,
  onClick,
  id,
  name,
  className,
  label,
  html,
  href,
  target,
  variant,
  wrapperClass,
}) => {
  const Tag = href ? 'a' : 'button';
  const isPrimary = variant.includes('primary');
  const content = html ? (
    <span dangerouslySetInnerHTML={{ __html: html }} />
  ) : (
    label
  );

  const primaryLabelWrapperClasses = {
    'primary-dark-stroke':
      'text-black group-hover:border-black group-hover:bg-black/20 group-disabled:bg-transparent border-spd-disabled group-disabled:border-spd-disabled',
    'primary-light-stroke':
      'text-white border-grey-200 group-hover:border-white group-disabled:bg-black group-disabled:border-spd-grey-400 bg-transparent group-focus:border-spd-blue group-hover:bg-white/20 group-disabled:text-spd-grey-400 group-focus:text-white',
    'primary-dark-fill':
      'bg-black text-white group-hover:bg-black/20 border-black group-hover:text-black group-disabled:bg-spd-disabled group-disabled:text-spd-grey-300 group-focus:text-white group-disabled:border-spd-disabled',
    'primary-light-fill':
      'bg-white text-black border-white group-hover:text-white group-hover:bg-white/20 group-focus:text-white group-focus:bg-black group-disabled:bg-black group-disabled:border-spd-disabled',
  };

  return (
    <Tag
      className={clsx(
        'group flex items-stretch disabled:text-spd-disabled focus:outline-none transition-colors w-fit ',
        {
          'mx-[16px] focus:text-spd-blue focus:border-spd-blue': isPrimary,
          'bg-black text-white  border border-black px-[15px] py-2.5 gld-utility hover:text-black hover:bg-white disabled:bg-white disabled-text-spd-disabled disabled:border-spd-disabled focus:text-black focus:bg-white focus:border-spd-focus uppercase':
            variant === 'secondary',
          'focus:border-b-spd-focus gld-utility border-b hover:border-grey-300 disabled:border-spd-disabled disabled:text-spd-disabled hover:mb-0 mb-px hover:border-b-2 disabled:mb-0 disabled:border-b uppercase':
            variant === 'tertiary',
        },
        className,
      )}
      disabled={disabled}
      type={type}
      onClick={onClick}
      id={id}
      name={name}
      href={href}
      target={target}
    >
      {isPrimary ? (
        <div
          className={clsx(
            'relative group-hover:text-black text-spd-grey-200 group-disabled:text-spd-disabled transition-colors group-focus:text-spd-focus',
            wrapperClass,
          )}
        >
          <BeveledIcon variant={variant} side="left" />

          <div
            class={clsx(
              'border-y text-center group-disabled:text-spd-disabled text-nowrap pb-[7px] pt-[10px] group-focus:border-spd-blue spd-utility min-w-[120px] px-2 cursor-pointer group-disabled:cursor-auto transition-colors  ',
              primaryLabelWrapperClasses[variant],
            )}
          >
            {content}
          </div>
          <BeveledIcon variant={variant} side="right" />
        </div>
      ) : (
        content
      )}
    </Tag>
  );
};

export default (element, data) => {
  if (!data) {
    return;
  }
  const init = async () => {
    render(<Button {...data} />, element);
  };
  init();
};
